import { render, staticRenderFns } from "./image.vue?vue&type=template&id=4defcee8&scoped=true&"
import script from "./image.js?vue&type=script&lang=js&"
export * from "./image.js?vue&type=script&lang=js&"
import style0 from "./image.css?vue&type=style&index=0&lang=css&"
import style1 from "./image.css?vue&type=style&index=1&id=4defcee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defcee8",
  null
  
)

export default component.exports